<ul *ngIf="children?.length" class="list-group">
  <li *ngFor="let child of children" [@fadeAnimation]="child.deleted ? 'deleted' : 'active'"  class="list-group-item" [ngClass]="{ 'deleted-category': child.deleted }">
    <div class="input-button-wrapper">
      <div class="category-name">{{ child.name }}</div>
      <div class="d-flex gap-2">
        <button 
          *ngIf="child.children?.length" 
          class="btn btn-outline-secondary" 
          (click)="toggleSubcategories(child.category_id)">
          {{ expandedNodes.has(child.category_id) ? '− Collapse' : '+ Expand' }}
        </button>
  
        <button 
          class="btn btn-dark" 
          (click)="emitAddSubcategory(child.category_id)"
          [ngClass]="{ 'active': parentIdForNewCategory === child.category_id }">
          + Add Subcategory
        </button>
  
        <button 
          class="btn" 
          [ngClass]="child.deleted ? 'btn-success' : 'btn-danger'"
          (click)="child.deleted ? confirmRestoreCategory(child) : confirmDeleteCategory(child)">
          {{ child.deleted ? 'Restore' : 'Delete' }}
        </button>

  
      </div>
    </div>
  
    <div *ngIf="expandedNodes.has(child.category_id)" class="mt-2">
      <app-category-node
        [children]="child.children"
        [parentIdForNewCategory]="parentIdForNewCategory"
        (addSub)="addSub.emit($event)"
        (deleteCategoryEvent)="deleteCategoryEvent.emit($event)"
        (restoreCategoryEvent)="restoreCategoryEvent.emit($event)">
      </app-category-node>
    </div>
  </li>
</ul>
